import PlanFileData from "@/pages/takeoff/context/project-measure/models/plan-file-data.ts";
import ProjectFilePlanReducerAction from "./project-file-plan-reducer-action.ts";

const fileReducer = (
    draft: PlanFileData,
    action: ProjectFilePlanReducerAction
): PlanFileData => {
    switch (action.type) {
        case 'change-origin':
            draft.setOrigin(action.origin.id);
            draft.setDirtyFlag(true);
            break;
        case 'add-origin':
            draft.addOrigin(action.origin);
            draft.setOrigin(action.origin.id);
            draft.setDirtyFlag(true);
            break;
        case 'delete-origin':
            draft.deleteOrigin(action.originId);
            draft.setDirtyFlag(true);
            break;
        case 'set-origin':
            draft.setOrigin(action.originId);
            break;
        case 'reset-origin':
            draft.resetOrigin();
            draft.setDirtyFlag(true);
            break;
        case 'set-relative-origin':
            draft.setRelativeOrigin(action.originId);
            draft.setDirtyFlag(true);
            break;
        case 'set-dirty-flag':
            draft.setDirtyFlag(action.isDirty);
            break;
        case 'reset':
            return action.data;
        default:
            throw new Error('Unknown action type');
    }

    return draft;
}

export default fileReducer;